const getLabelsToAdd = (currentLabels, selectedLabels) => {
  if (!currentLabels) {
    return selectedLabels;
  }

  // Unique array elements
  return [...new Set([...currentLabels, ...selectedLabels])];
};

export default getLabelsToAdd;